import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sub-panel',
  templateUrl: './sub-panel.component.html',
  styleUrl: './sub-panel.component.less'
})
export class SubPanelComponent {
  @Input() title = '';
  @Input() className = '';
  @Input() isRequired = false;
}
